import posthog from "posthog-js";
import InlineBanner from "../../../components/banner/InlineBanner";
import { useTranslation } from "../../../state/i18n";
import { useCustomerState } from "../../../state/customer";
import LegacyPlatformService from "../../../services/LegacyPlatformService";
import { POSTHOG_EVENTS } from "../../../services/PostHogService";
import { BannerComponent } from "./banners.tsx";

const NewPlatformBanner: BannerComponent = (props) => {
  const { t } = useTranslation();
  const customer = useCustomerState();
  const legacyPlatformOverviewUrl = LegacyPlatformService.createLegacyPlatformOverviewUrl(customer.customerId);

  return (
    <InlineBanner
      onDismiss={props.onDismiss}
      status="upgrade"
      title={t(($) => $.NEW_PLATFORM_BANNER_TITLE)}
      description={t(($) => $.NEW_PLATFORM_BANNER_DESCRIPTION)}
      primaryAction={{
        label: t(($) => $.NEW_PLATFORM_BANNER_PRIMARY_BUTTON),
        onClick: () => {
          posthog.capture(POSTHOG_EVENTS.LEGACY_PLATFORM_OPENED, { source: "banner" });
          window.location.assign(legacyPlatformOverviewUrl);
        },
      }}
      secondaryAction={{
        label: t(($) => $.NEW_PLATFORM_BANNER_SECONDARY_BUTTON),
        onClick: () => window.open("https://links.moreapp.com/platform-feedback", "_blank", "noopener"),
      }}
    />
  );
};

export default NewPlatformBanner;
